import React from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import useLocale from "../../../../hooks/useLocale";
import ls from "local-storage";
import { useMutation } from "react-query";
import { Typography } from "@material-ui/core";
import GovGrButton from "../../../../components/GovGrButton";
import GovGrTextField from "../../../../components/GovGrTextField";
import { fetchAmkaAndVerify } from "../../../../services/amkaExternalUser";

import CustomAlert from "../../../components/CustomAlert";
import { useState } from "react";
import { Redirect, useHistory } from "react-router-dom";

const AmkaVerification = () => {
  const { t } = useLocale();
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const { push } = useHistory();

  const [amkaverification] = useState(!ls("amka_verified"));

  let initialValues = { amka: "" };

  let validationSchema = Yup.object().shape({
    amka: Yup.string()
      .required(t("Field is required"))
      .min(11, t("Field must be 11 digits"))
      .max(11, t("Field must be 11 digits")),
    // .test(
    //   "len",
    //   t("Field must be 11 digits"),
    //   // (val) => parseInt(val).toString().length === 11
    //   (val) => {
    //     const length = parseInt(val).toString().length;
    //     debugger;
    //     return length === 11;
    //   }
    // ),
  });

  const { mutate } = useMutation(fetchAmkaAndVerify, {
    onSuccess: (data) => {
      if (data.data === "AMKA ok") {
        ls.set("amka_verified", 1);
        push("/");
      }
      // If 200 then redirect to dashboard
    },
    onError: (error) => {
      // if 406 then setError that amka is no good
      if (error.response.status === 406) {
        setError(true);
        setErrorMessage(t("Wrong AMKA"));
      } else {
        setError(true);
        setErrorMessage(t("A network error occured, please try again later"));
      }
    },
  });

  const handleSubmit = (amka) => {
    mutate({ amka });
  };
  return (
    <div>
      {!amkaverification ? (
        <Redirect to="/" />
      ) : (
        <>
          <CustomAlert
            open={!!error}
            close={() => {
              setError(false);
            }}
            message={errorMessage}
          />
          <Typography variant="h6">
            {t("Please type your AMKA number in the below field")}
          </Typography>

          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
              const { amka } = values;
              handleSubmit(amka);
              setSubmitting(false);
            }}
          >
            {({ onSubmit }) => (
              <Form>
                <div className="lg:w-1/6 m-5">
                  <GovGrTextField
                    variant="outlined"
                    name="amka"
                    margin="normal"
                    label={t("AMKA")}
                    className="mr-5"
                  />
                </div>
                <div className="p-5">
                  <GovGrButton
                    buttonText={t("Submit")}
                    type="submit"
                    onSubmit={onSubmit}
                  />
                </div>
              </Form>
            )}
          </Formik>
        </>
      )}
    </div>
  );
};

export default AmkaVerification;
